import React from 'react'

import { Col, Grid } from '../../packages/kiti/components/structure/Grid'
import Icon from '../../packages/kiti/components/shapes/Icon'
import Link from '../../packages/kiti/components/actions/Link'
import Text from '../../packages/kiti/components/presentation/Text'

const FilterLink = ({ icon, label, isSelected, onClick, value }) => {
  isSelected = isSelected || !!value
  const iconColor = !!isSelected ? 'dark1' : 'light5'
  const color = !!isSelected ? 'dark1' : 'dark3'

  return (
    <Col>
      <Link onClick={onClick}>
        <Grid align="center" gutter={0.2}>
          <Icon name={icon} color={iconColor} />
          <Text color={color} weight={isSelected ? 800 : 500}>
            {value || label}
          </Text>
        </Grid>
      </Link>
    </Col>
  )
}

export default FilterLink
